export default __webpack_public_path__ + "static/logo-ucc-2018-aeb2c7deca4775caa8062a60bfc1012b.svg";